function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCaretBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.587,11.414C9.368,12.195 10.637,12.195 11.417,11.414L19.414,3.417C19.989,2.843 20.158,1.987 19.845,1.237C19.533,0.487 18.808,-0 17.996,-0L2.003,0.006C1.197,0.006 0.466,0.494 0.153,1.243C-0.159,1.993 0.016,2.849 0.584,3.424L8.581,11.42L8.587,11.414Z",
    style: {
      fill: "#00659d",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCaretBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/caret-blue.b0ef4b21130220682728800d52f70afa.svg";